(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.nl = {}));
  }(this, (function (exports) { 'use strict';
  
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined
        ? window.flatpickr
        : {
            l10ns: {},
        };
    var Nederlands = {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: ["zo", "ma", "di", "wo", "do", "vr", "za"],
            longhand: [
                "zondag",
                "maandag",
                "dinsdag",
                "woensdag",
                "donderdag",
                "vrijdag",
                "zaterdag",
            ],
        },
        months: {
            shorthand: [
                "jan",
                "feb",
                "mrt",
                "apr",
                "mei",
                "jun",
                "jul",
                "aug",
                "sep",
                "okt",
                "nov",
                "dec",
            ],
            longhand: [
                "januari",
                "februari",
                "maart",
                "april",
                "mei",
                "juni",
                "juli",
                "augustus",
                "september",
                "oktober",
                "november",
                "december",
            ],
        },
        ordinal: function (nth) {
            return "e";
        },
        rangeSeparator: " tot ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll om de waarde te verhogen",
        toggleTitle: "Klik om te wisselen",
        time_24hr: true,
    };
    fp.l10ns.nl = Nederlands;
    var nl = fp.l10ns;
  
    exports.Nederlands = Nederlands;
    exports.default = nl;
  
    Object.defineProperty(exports, '__esModule', { value: true });
  
  })));